import 'css-chunksrc/client/scenes/project/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_ofbf4_1",
  "group": "_group_ofbf4_6",
  "wrapper": "_wrapper_ofbf4_13",
  "icon": "_icon_ofbf4_46",
  "titleStart": "_titleStart_ofbf4_52",
  "titleEnd": "_titleEnd_ofbf4_58",
  "input": "_input_ofbf4_65",
  "calendar": "_calendar_ofbf4_80"
};